import * as t from 'io-ts';
import uniq from 'lodash/uniq';
import flatMap from 'lodash/flatMap';

var PERMISSION_WRITE = 'WRITE';
var PERMISSION_READ = 'READ';
var PERMISSION_PUBLISH = 'PUBLISH';
var PERMISSION_DEBUG = 'DEBUG';
var PERMISSION_APPROVE = 'APPROVE TAGGING QUALITY';
var PERMISSION_WRITE_DEI = 'WRITE DEI';
var RoleName;

(function (RoleName) {
  RoleName["DEI"] = "DEI";
  RoleName["LIBRARY_READ"] = "Library Read";
  RoleName["LIBRARY_WRITE"] = "Library Write";
})(RoleName || (RoleName = {}));

var AuthResponseCodec = t.type({
  access_token: t.string,
  id_token: t.string,
  // jwt encoded user data
  refresh_token: t.string,
  // for refresh wf?
  token_type: t.string,
  expires_in: t.number,
  user_data: t.string,
  return_to: t.string
});
var MaestroRoleCodec = t.type({
  name: t.string,
  attributes: t.union([t.undefined, t.array(t.unknown)]),
  functionalAbilities: t.union([t.undefined, t.array(t.type({
    name: t.string
  }))])
});
var MaestroUserDataCodec = t.strict({
  'id.sapID': t.string,
  'id.employeeID': t.string,
  given_name: t.string,
  family_name: t.string,
  email: t.string,
  roles: t.union([t.undefined, t.array(MaestroRoleCodec)]),
  rolesFullAssertion: t.union([t.undefined, t.array(t.unknown)])
});
var RoleCodec = t.type({
  name: t.string,
  functionalAbilities: t.array(t.type({
    name: t.string
  }))
});
var MyIDUserCodec = t.strict({
  'id.sapID': t.string,
  'id.employeeID': t.string,
  given_name: t.string,
  family_name: t.string,
  email: t.string,
  roles: t.union([t.undefined, t.array(RoleCodec)]),
  'x-gsso-myid': t.string,
  'x-gsso-myid-refresh-token': t.string,
  id_token: t.string
});
var extractPermissions = function extractPermissions(user) {
  var roles = user.roles || [];
  return uniq(flatMap(roles, function (role) {
    return role.functionalAbilities.map(function (fa) {
      return fa.name;
    });
  }));
};

export { AuthResponseCodec, MaestroRoleCodec, MaestroUserDataCodec, MyIDUserCodec, PERMISSION_APPROVE, PERMISSION_DEBUG, PERMISSION_PUBLISH, PERMISSION_READ, PERMISSION_WRITE, PERMISSION_WRITE_DEI, RoleName, extractPermissions };
